import { compose } from 'redux';
import { core } from '@updater/redux-http-request';
import { jsonApi } from '../http-request';

export const actions = jsonApi.createUpdResourceFacade('moves');

actions.verification = (id, body) => {
  const create = actions.create(body);
  const { payload } = create;

  return {
    ...create,
    payload: {
      ...payload,
      url: `${payload.url}/${id}/verifications`,
    },
  };
};

actions.decline = (moveId, itemType, reason, action = {}) => {
  return actions.action(`${moveId}/${itemType}/${reason}`, null, action);
};

actions.undecline = compose(
  core._delete,
  actions.decline
);
